import { Box, Text } from '../../../../../../mads';
import { useI18n } from '../../../../../../shared/I18n';

import React from 'react';

const ApplicantInsightsErrorState: React.FC = () => {
    const gt = useI18n();
    return (
        <Box data-testid="applicant-insights-error-state">
            <Box>
                <Text
                    level={2}
                    variant="secondary"
                    sx={{ color: 'foreground.strong', marginStart: 1 }}
                >
                    {gt.gettext("We weren't able to load applicant insights.")}
                </Text>
            </Box>
        </Box>
    );
};

export default ApplicantInsightsErrorState;
